import React, { useState, useEffect } from "react";
import Fetchtable from "../components/Fetchtable";
import { Select, message } from "antd";
import axios from "axios";
import useAuth from "../hooks/useAuth";

const { Option } = Select;
const URL = process.env.REACT_APP_API_URL;

const Reports = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [data, setData] = useState([]);
  const { token } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `${URL}/api/candidatesreport`;
        if (selectedCategory !== "all") {
          url += `?selectedCategory=${selectedCategory}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to fetch data");
      }
    };

    fetchData();
  }, [selectedCategory, token]);

  const userColumns = [
    {
      name: "Date",
      selector: (row) => {
        if (row.dateCreated) {
          const date = new Date(row.dateCreated);
          const dateString = date.toLocaleDateString();
          return <span>{dateString}</span>;
        } else {
          return "-";
        }
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <span className="custom-cell" style={{ textTransform: "capitalize" }}>
          {row.fullName}
        </span>
      ),
    },
    {
      name: "Email",
      width: "200px",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <span className="custom-cell">{row.email}</span>,
    },
    {
      name: "Quantitative",
      width: "130px",
      center: true,
      selector: (row) => row.quantitative.score !== -1 ? `${row.quantitative.score} (${row.quantitative.status})` : "0",
      sortable: true,
      omit: selectedCategory === "ANI-Test"
    },
    {
      name: "Vocabulary",
      width: "125px",
      center: true,
      selector: (row) => row.vocabulary.score !== -1 ? `${row.vocabulary.score} (${row.vocabulary.status})` : "0",
      sortable: true,
      omit: selectedCategory === "ANI-Test"
    },
    {
      name: "Psychometric",
      width: "140px",
      center: true,
      selector: (row) => row.psychometric.score !== -1 ? `${row.psychometric.score} (${row.psychometric.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Non-Technical" || selectedCategory === "ANI-Test",
    },
    {
      name: "Java",
      width: "110px",
      center: true,
      selector: (row) => row.java.score !== -1 ? `${row.java.score} (${row.java.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Non-Technical" || selectedCategory === "ANI-Test",
    },
    {
      name: "Excel",
      width: "120px",
      center: true,
      selector: (row) => row.excel.score !== -1 ? `${row.excel.score} (${row.excel.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "ANI-Test",
    },
    {
      name: "Accounts",
      width: "130px",
      center: true,
      selector: (row) => row.accounts.score !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "ANI-Test",
    },
    {
      name: "Power BI And Data Science",
      width: "230px",
      center: true,
      selector: (row) => row.power_Bi_And_Data_Science.status || '',
      // selector: (row) => row.power_Bi_And_Data_Science.status !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "Data Engineer",
      width: "150px",
      center: true,
      selector: (row) => row.data_Engineer.status || '',
      // selector: (row) => row.power_Bi_And_Data_Science.status !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "AEP CJA Consultant",
      width: "190px",
      center: true,
      // selector: (row) => row.power_Bi_And_Data_Science.status || '',
      selector: (row) => row.aep_Cja.score !== -1 ? `${row.aep_Cja.score} (${row.aep_Cja.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "AEP CDP Architect",
      width: "190px",
      center: true,
      // selector: (row) => row.power_Bi_And_Data_Science.status || '',
      selector: (row) => row.aep_Cdp_Architect.score !== -1 ? `${row.aep_Cdp_Architect.score} (${row.aep_Cdp_Architect.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "Adobe Analytics Implementation",
      width: "270px",
      center: true,
      // selector: (row) => row.power_Bi_And_Data_Science.status || '',
      selector: (row) => row.adobe_Analytics_Implementation.score !== -1 ? `${row.adobe_Analytics_Implementation.score} (${row.adobe_Analytics_Implementation.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "Gen AI",
      width: "110px",
      center: true,
      selector: (row) => row.gen_AI.status || '',
      // selector: (row) => row.power_Bi_And_Data_Science.status !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "Gen AI Theory",
      width: "150px",
      center: true,
      selector: (row) => row.gen_AI_Theory.status || '',
      // selector: (row) => row.power_Bi_And_Data_Science.status !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
    {
      name: "Big Query",
      width: "130px",
      center: true,
      selector: (row) => row.big_Query.status || '',
      // selector: (row) => row.power_Bi_And_Data_Science.status !== -1 ? `${row.accounts.score} (${row.accounts.status})` : "0",
      sortable: true,
      omit: selectedCategory === "Technical" || selectedCategory === "Non-Technical",
    },
  ];

  return (
    <div className="vh-page">
      <Fetchtable
        url={`${URL}/api/candidatesreport`}
        columns={userColumns}
        filteredData={data}
        fileName="Scores"
        extraContent={
          <label>
            <Select
              value={selectedCategory}
              onChange={(value) => setSelectedCategory(value)}
              style={{ minWidth: "150px", margin: "2px" }}
            >
              <Option value="all">All</Option>
              <Option value="Technical">Technical</Option>
              <Option value="Non-Technical">Non-Technical</Option>
              <Option value="ANI-Test">ANI-Test</Option>
            </Select>
          </label>
        }
      />
    </div>
  );
};

export default Reports;
